export default {
	name: "Fulfil.io",
	type: "fulfil",
	category: "Shipping",
	icon: "local_shipping",
	apiFields: [
		{
			field: "apiKey",
			label: "API Key",
			type: "text"
		},
		{
			field: "subdomain",
			label: "Subdomain",
			type: "text",
			helpText: "E.g., hioperator"
		}
	],
	cardFields: [
		{
			field: "action",
			label: "Fulfil Action",
			type: "dropdown",
			items: [
				{
					text: "Find orders",
					value: "find orders"
				},
				{
					text: "Get order",
					value: "get order"
				},
				{
					text: "Update record",
					value: "update record"
				}
			]
		},
		{
			field: "fieldType",
			label: "Field to use",
			type: "dropdown",
			items: [
				{
					text: "Order number",
					value: "rec_name"
				}
			],
			displaylogic: [
				{
					action: "appear",
					rules: [
						{
							if: "action",
							state: "is",
							value: "find orders"
						}
					]
				}
			]
		},
		{
			field: "recordType",
			label: "Type of Record",
			type: "dropdown",
			items: [
				{
					text: "Address",
					value: "address"
				},
				{
					text: "Sales Order",
					value: "sales order"
				},
				{
					text: "Shipment",
					value: "shipment"
				}
			],
			displaylogic: [
				{
					action: "appear",
					rules: [
						{
							if: "action",
							state: "is",
							value: "update record"
						}
					]
				}
			]
		},
		{
			field: "value",
			label: "Value",
			type: "text",
			displaylogic: [
				{
					action: "appear",
					rules: [
						{
							if: "action",
							state: "is",
							value: "find orders"
						}
					]
				}
			]
		},
		{
			field: "value",
			label: "Order ID",
			type: "text",
			displaylogic: [
				{
					action: "appear",
					rules: [
						{
							if: "action",
							state: "is",
							value: "get order"
						}
					]
				}
			]
		},
		{
			field: "recordId",
			label: "Record ID",
			type: "text",
			displaylogic: [
				{
					action: "appear",
					rules: [
						{
							if: "action",
							state: "is",
							value: "update record"
						}
					]
				}
			]
		},
		{
			field: "value",
			label: "Update",
			type: "text",
			displaylogic: [
				{
					action: "appear",
					rules: [
						{
							if: "action",
							state: "is",
							value: "update record"
						}
					]
				}
			]
		}
	]
};
